module.exports = __webpack_public_path__ + "static/media/Bubbly_ios_4.4b95eef8.jpg";